import auth from '@/Middlewares/auth.js'
import ResourceRoute from '@/Setup/Routes/ResourceRoute.js'
import RouteGroup from '@/Setup/Routes/RouteGroup.js'

export const emailAccountRoutes = new RouteGroup(() => {
  return [
    ...new ResourceRoute('email-accounts', {
      list: () => import(/* webpackChunkName: "admin" */ './Pages/List.vue'),
    })
      .except(['create', 'edit'])
      .permissions({
        list: 'email-accounts.view',
      })
      .resolve(),
  ]
})
  .middlewares([auth])
  .resolve()
